<template>
  <v-layout row justify-center>
    <v-dialog v-model="showSubscriptionsDetail" max-width="630px"
      transition="dialog-bottom-transition" @keydown.esc="showSubscriptionsDetail = false">
      <v-card>
        <v-toolbar color="blue-grey lighten-5">
          <v-spacer></v-spacer>
          <v-toolbar-title class="text-xs-center">Detalhes</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="showSubscriptionsDetail = false">
            <v-icon>fal fa-times</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <div class="text-xs-center">
              <v-progress-circular v-if="loadingData" color="deep-orange darken-2" indeterminate></v-progress-circular>
            </div>
            <v-layout wrap v-if="!loadingData">
              <p v-if="plan && subscription && subscription.charges_detail">
                Plano: <strong>{{ plan.description }}</strong>
                <br>
                <span v-if="subscription.charges_detail.last_charged_date">
                  Último pagamento:
                  <strong>{{ subscription.charges_detail.last_charged_date | moment('LLL') }}</strong>
                </span>
                <br>
                <span v-if="subscription.charges_detail.next_payment_date">
                  Próximo pagamento:
                  <strong>{{ subscription.charges_detail.next_payment_date | moment('LLL') }}</strong>
                </span>
                <br>
                <span v-if="subscription.charges_detail.charged_amount">
                  Total pago em todo o período:
                  <strong>{{ subscription.charges_detail.charged_amount | formatCurrency }}</strong>
                </span>
                <br>
                <span v-if="subscription.charges_detail.last_charged_amount">
                  Último valor pago:
                  <strong>{{ subscription.charges_detail.last_charged_amount | formatCurrency }}</strong>
                </span>
                <br>
                <span v-if="subscription.charges_detail.last_charged_amount">
                  Status:
                  <strong>{{ subscription.status }}</strong>
                </span>
              </p>

              <v-expansion-panel v-if="payment && !loadingData">
                <v-expansion-panel-content expand-icon="fal fa-angle-down">
                  <div slot="header">Metadados da transação</div>
                  <section class="mx-4">
                    <tree-view :data="payment" :options="{ maxDepth: 5 }"></tree-view>
                  </section>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn round depressed small outline color="deep-orange darken-2" v-if="subscription.status !== 'cancelled'"
            @click="updateSubscriptionStatus('cancelled', 'cancelar')" :loading="loadingRequest">
            <v-icon small left>fal fa-times-circle</v-icon>
            Cancelar plano
          </v-btn>
          <v-btn round depressed small outline @click="updateSubscriptionStatus('paused', 'pausar')"
            v-if="subscription.status !== 'paused' && subscription.status !== 'cancelled'" :loading="loadingRequest">
            <v-tooltip bottom>
              <span slot="activator">
                <v-icon small left>fal fa-pause-circle</v-icon>
                Pausar plano
              </span>
              <span>As cobranças serão pausadas</span>
            </v-tooltip>
          </v-btn>
          <v-btn round depressed small outline @click="updateSubscriptionStatus('authorized', 'retomar')"
            v-if="subscription.status === 'paused'" :loading="loadingRequest">
            <v-icon small left>fal fa-pause-circle</v-icon>
            Retomar plano
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'

export default {
  props: ['userMP'],

  data: () => ({
    showSubscriptionsDetail: false,
    loadingRequest: false,
    loadingData: false,
    subscription: {},
    plan: {},
    subscriptionData: {},
    payment: {}
  }),

  methods: {
    updateSubscriptionStatus (status, title, confirmUnRequired) {
      this.loadingRequest = true
      const path = `${API.mpSubscriptions}/${this.subscription.id}`
      const params = { status: status }

      if (!confirmUnRequired) {
        confirm(`Tem certeza que deseja ${title} o plano ?`) && this.updateSubscriptionStatus(status, title, true)
        this.loadingRequest = false
        return
      }

      axios.put(path, params).then(response => {
        this.showSubscriptionsDetail = false
        this.loadingRequest = false
        EventBus.$emit('loadTransactions')
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', { message: 'Erro ao atualizar assinatura', color: 'error' })
      })
    },

    loadPlan (id) {
      if (!id) return
      const path = `${API.mpPlans}/${id}`

      axios.get(path).then(response => {
        if (response && response.data && response.data.plan.response) {
          this.plan = response.data.plan.response
        }
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', { message: 'Erro ao carregar detalhes do plano', color: 'error' })
      })
    },

    loadSubscription (id) {
      if (!id) return
      const path = `${API.mpSubscriptions}/${id}`

      axios.get(path).then(response => {
        if (response && response.data && response.data.preapproval.response) {
          this.subscription = response.data.preapproval.response
        }
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', { message: 'Erro ao carregar detalhes da assinatura', color: 'error' })
      })
    },

    loadPayment (id) {
      if (!id) return
      this.loadingData = true
      const path = `${API.mpPayments}/${id}`

      axios.get(path).then(response => {
        this.loadingData = false
        if (response && response.data && response.data.payment.response) {
          this.payment = response.data.payment.response
          if (this.payment.metadata.subscription_id) this.loadSubscription(this.payment.metadata.subscription_id)
          if (this.payment.metadata.plan_id) this.loadPlan(this.payment.metadata.plan_id)
        }
      }).catch(errors => {
        this.loadingData = false
        EventBus.$emit('showSnackbar', { message: 'Erro ao carregar detalhes do pagamento', color: 'error' })
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('showSubscriptionsDetail')
    EventBus.$off('showSubscriptionsDetailData')
  },

  mounted () {
    EventBus.$on('showSubscriptionsDetail', data => {
      this.showSubscriptionsDetail = data
    })

    EventBus.$on('showSubscriptionsDetailData', data => {
      this.subscriptionData = data
      if (data && data.id) this.loadPayment(data.id)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/financial/AdminSubscriptionsDetail.vue